/**
 * `/settings/firm` — and **`/settings/firm#social`**, which Wave 14 moved to
 * `/site/social` (C13, ADR-0032 §4: *"moved pages keep working at their old
 * addresses"*). A hash is not part of a route match, so the old address is
 * recognised here and sent on; every other hash stays on *Your firm*, which
 * scrolls to it. The other two moved addresses are plain redirects in
 * `router.tsx`, from `MOVED_ADDRESSES`.
 */

import { Navigate, useLocation } from 'react-router'

import { MOVED_SOCIAL } from './cards'
import { FirmProfilePage } from './FirmProfile'

export function FirmOrSocial() {
  const { hash } = useLocation()
  if (hash.toLowerCase() === '#social') return <Navigate to={MOVED_SOCIAL} replace />
  return <FirmProfilePage />
}
